import {JSX, SVGProps} from "react";

export type ArrowRightIconProps = SVGProps<SVGSVGElement>;

export function ArrowRightIcon({width = 24, height = 24, ...props}: ArrowRightIconProps): JSX.Element {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true} {...props}>
            <path
                d="M9.62001 12.5467C9.49334 12.5467 9.36667 12.5 9.26667 12.4C9.07334 12.2067 9.07334 11.8867 9.26667 11.6933L12.96 8L9.26667 4.30667C9.07334 4.11334 9.07334 3.79334 9.26667 3.6C9.46001 3.40667 9.78001 3.40667 9.97334 3.6L14.02 7.64667C14.2133 7.84 14.2133 8.16 14.02 8.35333L9.97334 12.4C9.87334 12.5 9.74667 12.5467 9.62001 12.5467Z"
                fill="currentColor"
            />
            <path
                d="M13.5533 8.5H2.33333C2.05999 8.5 1.83333 8.27333 1.83333 8C1.83333 7.72667 2.05999 7.5 2.33333 7.5H13.5533C13.8267 7.5 14.0533 7.72667 14.0533 8C14.0533 8.27333 13.8267 8.5 13.5533 8.5Z"
                fill="currentColor"
            />
        </svg>
    );
}
